import { Badge } from "@/components/ui/badge";

export const money = (ccy, amt) =>
  `${ccy || "GHS"} ${Number(amt || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export const moneyMap = (map) => {
  const entries = Object.entries(map || {});
  if (!entries.length) return "—";
  return entries.map(([c, v]) => money(c, v)).join(" · ");
};

const COLORS = {
  // project status
  "Lead": "bg-slate/15 text-slate",
  "Confirmed": "bg-blue-100 text-blue-700",
  "Not Started": "bg-slate/15 text-slate",
  "In Progress": "bg-emerald-100 text-emerald-700",
  "Waiting for Customer": "bg-sky-100 text-sky-700",
  "On Hold": "bg-amber-100 text-amber-700",
  "Completed": "bg-green-100 text-green-700",
  "Cancelled": "bg-red-100 text-red-700",
  // phase status
  "Internal Review": "bg-indigo-100 text-indigo-700",
  "Customer Review": "bg-sky-100 text-sky-700",
  "Blocked": "bg-red-100 text-red-700",
  // payment status
  "Paid": "bg-green-100 text-green-700",
  "Partially Paid": "bg-amber-100 text-amber-700",
  "Due Soon": "bg-amber-100 text-amber-700",
  "Due": "bg-amber-100 text-amber-700",
  "Overdue": "bg-red-100 text-red-700",
  "Not Yet Due": "bg-slate/15 text-slate",
  "On track": "bg-green-100 text-green-700",
  "No milestones": "bg-slate/10 text-mutedink",
  // customer action
  "Requested": "bg-sky-100 text-sky-700",
  "Reminder Sent": "bg-amber-100 text-amber-700",
  "Received": "bg-green-100 text-green-700",
  "No Longer Required": "bg-slate/15 text-slate",
  // change request
  "Under Review": "bg-amber-100 text-amber-700",
  "Approved": "bg-green-100 text-green-700",
  "Declined": "bg-red-100 text-red-700",
  "Implemented": "bg-blue-100 text-blue-700",
};

export const StatusBadge = ({ status }) => (
  <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-600 ${COLORS[status] || "bg-slate/15 text-slate"}`}>
    {status}
  </span>
);

export const KpiCard = ({ label, value, tone = "navy", sub }) => {
  const tones = {
    navy: "text-navy",
    green: "text-green-600",
    amber: "text-amber-600",
    red: "text-red-600",
    blue: "text-sky-600",
  };
  return (
    <div className="rounded-xl border border-navy/10 bg-white p-4 shadow-sm" data-testid={`kpi-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="text-[0.7rem] font-600 uppercase tracking-wide text-mutedink">{label}</div>
      <div className={`mt-1 font-serif text-2xl font-700 ${tones[tone]}`}>{value}</div>
      {sub && <div className="mt-0.5 text-xs text-mutedink">{sub}</div>}
    </div>
  );
};

export const Progress = ({ value }) => (
  <div className="flex items-center gap-2">
    <div className="h-2 w-full overflow-hidden rounded-full bg-navy/10">
      <div className="h-full rounded-full bg-gold" style={{ width: `${value || 0}%` }} />
    </div>
    <span className="w-9 text-right text-xs font-600 text-navy">{value || 0}%</span>
  </div>
);

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-1 block text-xs font-600 text-navy">{label}</span>
    {children}
  </label>
);
